"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pieChartData = exports.colorDiv = exports.singlePieChartField = exports.root = exports.textStyles = exports.styles = void 0;

var _reactEmotion = require("react-emotion");

var styles = function styles(size, theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:", size * 1.4, "px;height:", size * 1.4, "px;transform:scale(0.8);transform-origin:0 0;", size === 'warning' && "\n    color: ".concat(theme.color, ";\n    fill: ").concat(theme.color, ";\n  "))
  );
}; // const StyledSVG = withTheme(styled.svg`${styles}`);


exports.styles = styles;

var textStyles = function textStyles(theme, mode) {
  return mode === 'dark' ?
  /*#__PURE__*/
  (0, _reactEmotion.css)("color:", theme.color.dark.silver, ";font-size:10px;") :
  /*#__PURE__*/
  (0, _reactEmotion.css)("color:", theme.color.black1, ";font-size:16px;");
}; // const TextForColor = withTheme(styled.div`${textStyles}`);


exports.textStyles = textStyles;

var root = function root() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;width:max-content;height:166px;")
  );
};

exports.root = root;

var singlePieChartField = function singlePieChartField(mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;align-items:center;", mode === 'dark' ? "\n  margin-bottom: 12px;" : "\n  margin-bottom: 20px;")
  );
};

exports.singlePieChartField = singlePieChartField;

var colorDiv = function colorDiv(color, mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-right:12px;background:", color, ";", mode === 'dark' ? "\n  width: 8px;\n  height: 8px;" : "\n  width: 18px;\n  height: 18px;\n  border-radius: 3px;")
  );
};

exports.colorDiv = colorDiv;

var pieChartData = function pieChartData(mode) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;flex-direction:column;height:max-content;", mode === 'dark' ? "\n  margin-top: 24px;" : "\n  margin-top: 4px;")
  );
};

exports.pieChartData = pieChartData;